import { render, staticRenderFns } from "./DriverDocument.vue?vue&type=template&id=da04d0d0&"
import script from "./DriverDocument.vue?vue&type=script&lang=js&"
export * from "./DriverDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports